import manage from '@/pages/wastage/manage'
import list from '@/pages/wastage/list'
import add from '@/pages/wastage/add'
import edit from '@/pages/wastage/edit'
import wastageReqManage from '@/pages/wastage/reqManage'
import wastageSellReqAdd from '@/pages/wastage/addSellReq'
import wastageSellReqEdit from '@/pages/wastage/editSellRequest'
import sellInvoiceList from '@/pages/wastage/sellInvoiceList'
import sellInvoiceEdit from '@/pages/wastage/sellInvoiceEdit'
import sellInvoiceAdd from '@/pages/wastage/sellInvoiceAdd'


const routes = [
  {
    path:'/Wastage/Manage',
    component:manage,
    meta:{requiredAuth:true}
  },
  {
    path:'/Wastage/list',
    component:list,
    meta:{requiredAuth:true}
  },
  {
    path:'/AutoWastage/add',
    component:add,
    meta:{requiredAuth:true}
  },
  {
    path:'/AutoWastage/edit/:id',
    component:edit,
    meta:{requiredAuth:true}

  },
  {
    path: '/WastageSellRequest/Manage',
    component: wastageReqManage,
    meta: {requiredAuth: true}
  },
  {
    path: '/WastageSellRequest/Add',
    component: wastageSellReqAdd,
    meta: {requiredAuth: true}
  },
  {
    path: '/WastageSellRequest/edit/:id',
    component: wastageSellReqEdit,
    meta: {requiredAuth: true}
  },
  {
    path: '/WastageSellInvoice/list',
    component: sellInvoiceList,
    meta: {requiredAuth: true}
  },
  {
    path: '/WastageSellInvoice/add',
    component: sellInvoiceAdd,
    meta: {requiredAuth: true}
  },
  {
    path: '/WastageSellInvoice/Edit/:id',
    component: sellInvoiceEdit,
    meta: {requiredAuth: true}
  },
]

export default routes;